import { BoxProps } from '@mantine/core'
import useStyles from './index.styles'

type Props = {
  content: string
} & BoxProps

export const RichTextFormat = ({ content, className }: Props) => {
  const { classes, cx } = useStyles(undefined, {
    name: 'HealthTools',
  })
  return (
    <div
      className={cx(className, classes.root)}
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    />
  )
}
